<template>
  <range-control
    v-bind="attrs"
    @input="newValue => $emit('input', newValue)"
    @change="$event => $emit('change')"
  >
    <template
      v-slot="{ label, inputEventHandlers, inputBindings }"
      class="c-rangecontrol"
    >
      <label class="block text-var-xs select-none">
        <slot>{{ label }}</slot
        ><br />
        <input
          class="w-full cursor-pointer"
          type="range"
          v-bind="inputBindings"
          v-on="inputEventHandlers"
        />
      </label>
    </template>
  </range-control>
</template>

<script>
import RangeControl from './RangeControl'

export default {
  name: `LabelledRangeControl`,
  inheritAttrs: false,
  components: { RangeControl },
  props: [`value`, `name`, `minValue`, `maxValue`],
  computed: {
    attrs() {
      return { ...this.$props, ...this.$attrs }
    },
    label() {
      return this.$slots.default ? this.$slots.default.text : ``
    },
  },
}
</script>
